import { getEnvironment, REACT_APP_ONBOARDING_JOURNEY_URL } from "./environment";
import { SELECTED_PRADUCT_TYPE_ID_LOCAL_STORAGE_KEY } from "../Constants/constant";

export const toSentenceCase = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const redirectToPaymentPage = () => {
  const { PAYMENT_URL } = getEnvironment();
  if(window.parent){
    window.parent.location.href = PAYMENT_URL;
  }else{
    window.location.href = PAYMENT_URL;
  }
}

export const redirectToOnboardingJourney = (token) => {
  const redirectURL = `${REACT_APP_ONBOARDING_JOURNEY_URL}auto-login?token=${token}`;
  if(window.parent){
    return window.parent.location.href = redirectURL;
  }
  window.location.href = redirectURL;
}

export const strEncryptionSHA256 = async (str) => {
  if (!str) {
    return 'NA';
  }

  const data = new TextEncoder().encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

export const getSelectedProductType = (productID) => {
  const productId = productID || Number(localStorage.getItem(SELECTED_PRADUCT_TYPE_ID_LOCAL_STORAGE_KEY));
  const productMap = {
    1: "emi",
    2: "payday",
  };
  return productMap[productId] || "na";
}

export const redirectToExternalURL = (url) => {
  if(window.parent)
    window.parent.location.href = url;
  else 
    window.location.href = url;
}

export const getGeolocation = () => {
  return new Promise((resolve) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.log("Geolocation error:", error);
          resolve({ latitude: null, longitude: null });
        }
      );
    } else {
      console.log("Geolocation not supported");
      resolve({ latitude: null, longitude: null });
    }
  });
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Joins truthy class names: cx("a", cond && "b") -> "a b" or "a".
export const cx = (...classes) => classes.filter(Boolean).join(" ");

const getISTDateParts = (date) => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date(date));

  return {
    year: Number(parts.find((p) => p.type === "year").value),
    month: Number(parts.find((p) => p.type === "month").value),
    day: Number(parts.find((p) => p.type === "day").value),
  };
};

export const dayDiff = (startDate, endDate = new Date()) => {
  
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (
    !startDate ||
    Number.isNaN(start.getTime()) ||
    Number.isNaN(end.getTime())
  ) {
    return null;
  }

  const startParts = getISTDateParts(start);
  const endParts = getISTDateParts(end);

  const startUTC = Date.UTC(
    startParts.year,
    startParts.month - 1,
    startParts.day
  );

  const endUTC = Date.UTC(
    endParts.year,
    endParts.month - 1,
    endParts.day
  );

  return Math.floor(
    (startUTC - endUTC) / (1000 * 60 * 60 * 24)
  );
};